<template>
    <div v-if="asOfDates">
      <hp5-spacing-vertical xs="xs"></hp5-spacing-vertical>

      <hp5-label-decorator size="xs">
        <label>View network as of</label>
      </hp5-label-decorator>
      <div v-for="(date, index) in asOfDates" :key="date">
        <hp5-semantic size-selection="xs">
          <input :id="`input-${date}`" type="radio" name="asOfDate" v-model="filterContext.asOfDate" :value="date" />
          <label class="date-label" :for="`input-${date}`">
            {{ label(date, index) }}
          </label>
        </hp5-semantic>
      </div>
    </div>
  </template>
  
  <script setup>
    import { format } from 'date-fns'
    
    /**
     * This component manages the UI and state for the asOfDate filter.  AsOfDates only
     * apply to non-auutenticated find-care and only one plan.
     */

      const model = useFCPModel()
      const { filterContext, profile } = model
      const asOfDates = computed(() => profile.value.asOfDates)
  
      /**
       * The label to display for the date.
       */
      const label = (date, index) => {
        const dateParts = date.split('-')
        //Month is the index ( and therefore 0 based ) so subtract 1.
        const dt = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]))
        const formatted = format(dt, 'MMM do, yyyy')
        const today = format(new Date(), 'MMM do, yyyy')
        return formatted == today ? 'Today' : formatted
      }

  </script>
  
  <style scoped>
    .date-label {
      padding-left: var(--spacing-xs);
    }
  </style>